import React, { useContext, memo } from "react";
import Avatar from "@material-ui/core/Avatar";
import { UserContext } from "../../context/UserContext";
import { SidebarContext } from "../../context/SidebarContext";
import { SidebarData } from "./SidebarData";
import SubMenu from "./SubMenu";
import "./sidebar.css";

const Sidebar = () => {
  const { user } = useContext(UserContext);
  const { openSidebar } = useContext(SidebarContext);

  let drawerClasses = "sidebarDrawer";
  if (openSidebar) {
    drawerClasses = "sidebarDrawer open";
  }

  return (
    <div className={drawerClasses}>
      <nav className="sidebar">
        <div>
          <div>
            <Avatar className="avatar">
              <label className="labelAvatar">
                {user.Nome.substring(0, 1).toUpperCase()}
              </label>
            </Avatar>
            <div className="containerNameUser">
              <label className="nameUser">{user.Nome.substr(0, 15)}...</label>
            </div>
          </div>

          {SidebarData().map((item, index) => {
            return <SubMenu item={item} key={index} />;
          })}
        </div>
      </nav>
    </div>
  );
};

export default memo(Sidebar);
